import { supabase } from '../../../shared/lib/supabaseClient';

export async function getStudentRecord(lrn, gradeLevel) {
  const { data, error } = await supabase.rpc('get_public_student_record', {
    p_lrn: lrn,
    p_grade_level: gradeLevel || null,
  });

  if (error) throw error;
  return data;
}
